export class FilterObject {
  key: string;
  value: string;
  active: boolean;
  numeric: boolean;
  strictEquality: boolean; //Search string must exactly match field of object if true
  startsWith: boolean; //Only adds wildcard at end of search string if true, default adds wildcards at start and end.
  alwaysTriggerRequest: boolean;
  operation: FILTER_OPERATION;
  displayValue: any;

  constructor(
    key,
    value = '',
    active = false,
    numeric = false,
    strictEquality = false,
    startsWith = false,
    alwaysTriggerRequest = false,
    operation: FILTER_OPERATION,
    displayValue = ''
  ) {
    this.key = key;
    this.value = value;
    this.active = active;
    this.numeric = numeric;
    this.strictEquality = strictEquality;
    this.startsWith = startsWith;
    this.alwaysTriggerRequest = alwaysTriggerRequest;
    this.operation = operation;
    this.displayValue = displayValue;
  }
}

export enum FILTER_OPERATION {
  EQUALITY,
  NEGATION,
  GREATER_THAN,
  LESS_THAN,
  LIKE
}
